<template>
  <div class="profile-show" id="profileshow">
    <br>
    <div class="row">
      <div class="col-3 prof_container">
        <img id="prof_pic" src="https://www.sackettwaconia.com/wp-content/uploads/default-profile.png"/>
        <div class="middle">
          <div class="text">Upload a Profile Picture</div>
        </div>
      </div>
      <div class="col-6">
        <div v-if="user_data">
          <h1 class="better_font bigger_font">{{user_data.first_name}} {{user_data.last_name}}</h1>
        </div>
      </div>
      <div class="col-3">
        <div align="right">
          <a><img class="social" src="../../../assets/facebook.png"/></a>
          <a><img class="social" src="../../../assets/linkedin.png"/></a>
          <a><img class="social" src="../../../assets/twitter.png"/></a>
          <a><img class="social" src="../../../assets/instagram.png"/></a>
        </div>
      </div>
    </div>
    <br>
    <div v-if="empty">
      <div class="empty">
        <h3 class="emptyText better_font">This is where you will see your profile. This information will be used to save you time while filling out scholarship applications. Click below to get started. </h3>
        <br>
        <button class="btn btn-primary emptyBtn better_font" @click="() => {empty = false; basicEdit = true;}">
        Click here to add your basic information
        </button>
      </div>
    </div>
    <div v-else>
      <div class="better_font">
        <ul class="my_tabs">
          <li class="my_tabs" v-bind:class="{ show: tab == 'basicInfo' }" @click="tab = 'basicInfo'"><a>Basic Info</a></li>
          <li class="my_tabs" v-bind:class="{ show: tab == 'education' }" @click="tab = 'education'"><a>Education</a></li>
          <li class="my_tabs" v-bind:class="{ show: tab == 'workExperience' }" @click="tab = 'workExperience'"><a>Work Experience</a></li>
          <li class="my_tabs" v-bind:class="{ show: tab == 'scholarships' }" @click="tab = 'scholarships'"><a>Scholarships</a></li>
        </ul>
      </div>
      <br>
      <div v-if="tab == 'basicInfo'">
        <div v-if="basicEdit">
          <ProfileEdit @finishEdit="toggleEditBasicInfo"/>
        </div>
        <div v-else>
          <div v-if="basicEmpty">
            <EmptyMessage pageName="profile" @enterEdit="toggleEditBasicInfo"/>
          </div>
          <div v-else>
            <h1 class="better_font">Personal Information</h1>
            <div>
              <img class="display-img mr-3" src="../../../assets/birthday.png"/>
              <p class="display-text"> {{formatDate(this.profile.birthdate)}}</p>
            </div>
            <br>
            <div>
              <img class="display-img mr-3 mb-4" src="../../../assets/home.png"/>
              <div class="display-text">
                <p>{{this.profile.street}} {{this.profile.street2}}</p>
                <p>{{this.profile.city}}, {{this.profile.state}} {{this.profile.country}} {{this.profile.zip}}</p>
              </div>
            </div>
            <div v-if="guardians.length > 0">
              <hr/>
              <h1 class="better_font">Parents/Guardians</h1>
              <div v-for="(guardian, index) in this.profile.guardians" v-bind:key="guardian.id">
                <h3 class="better_font">Guardian {{index + 1}}</h3>
                <h5 class="better_font display-label mr-3 ml-3">Name:</h5>
                <p class="display-text">{{guardian.name}}</p>
                <br>
                <h5 class="better_font display-label mr-3 ml-3">City:</h5>
                <p class="display-text">{{guardian.city}}</p>
                <br>
                <h5 class="better_font display-label mr-3 ml-3">State:</h5>
                <p class="display-text">{{guardian.state}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button class="btn btn-primary better_font editBtn" @click="basicEdit = true">Edit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab == 'education'">
        <div v-if="schoolsEdit">
          <SchoolsEdit @finishEdit="toggleEditSchools"/>
        </div>
        <div v-else>
          <div v-if="schools.length == 0">
            <EmptyMessage pageName="education history" @enterEdit="toggleEditSchools"/>
          </div>
          <div v-else>
            <h1 class="better_font">Schools</h1>
            <div v-for="school in this.schools" v-bind:key="school.id">
              <h3 class="better_font">{{school.name}}</h3>
              <h5 class="better_font display-label mr-3 ml-3">Type:</h5>
              <p class="display-text">{{formatType(school.school_type)}}</p>
              <br>
              <div v-if="school.major">
                <h5 class="better_font display-label mr-3 ml-3">Major:</h5>
                <p class="display-text">{{school.major}}</p>
                <br>
              </div>
              <div v-if="school.minor">
                <h5 class="better_font display-label mr-3 ml-3">Minor:</h5>
                <p class="display-text">{{school.minor}}</p>
                <br>
              </div>
              <h5 class="better_font display-label mr-3 ml-3">Status:</h5>
              <p class="display-text">{{school.status.charAt(0).toUpperCase() + school.status.slice(1)}}</p>
              <br>
              <h5 class="better_font display-label mr-3 ml-3">Start Date:</h5>
              <p class="display-text">{{formatDate(school.start_date)}}</p>
              <br>
              <h5 class="better_font display-label mr-3 ml-3">Graduation Date:</h5>
              <p class="display-text">{{formatDate(school.graduation_date)}}</p>
              <br>
            </div>
            <div class="row">
              <div class="col-12">
                <button class="btn btn-primary better_font editBtn" @click="schoolsEdit = true">Edit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab == 'workExperience'">
        <div v-if="workExpEdit">
          <WorkExperiencesEdit @finishEdit="toggleEditWorkExp"/>
        </div>
        <div v-else>
          <div v-if="work_experiences.length == 0">
            <EmptyMessage pageName="work experience" @enterEdit="toggleEditWorkExp"/>
          </div>
          <div v-else>
            <h1 class="better_font">Work History</h1>
            <div v-for="workExp in this.work_experiences" v-bind:key="workExp.id">
              <h3 class="better_font">{{workExp.company}}</h3>
              <h5 class="better_font display-label mr-3 ml-3">Job Title:</h5>
              <p class="display-text">{{workExp.job_title}}</p>
              <br>
              <h5 class="better_font display-label mr-3 ml-3">Job Description:</h5>
              <p class="display-text">{{workExp.description}}</p>
              <br>
              <h5 class="better_font display-label mr-3 ml-3">Start Date:</h5>
              <p class="display-text">{{formatDate(workExp.start_date)}}</p>
              <br>
              <h5 class="better_font display-label mr-3 ml-3">End Date:</h5>
              <p class="display-text">{{formatDate(workExp.end_date)}}</p>
              <br>
            </div>
            <div class="row">
              <div class="col-12">
                <button class="btn btn-primary better_font editBtn" @click="workExpEdit = true">Edit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab == 'scholarships'">
        <div v-if="submissions.length != 0">
          <Submissions :submissions="submissions"/>
        </div>
        <div v-else>
          <EmptyMessage pageName="scholarships"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ProfileEdit from './ProfileEdit'
import WorkExperiencesEdit from './WorkExperiencesEdit'
import SchoolsEdit from './SchoolsEdit'
import EmptyMessage from './EmptyMessage'
import Submissions from './Submissions'

export default {
  components:{
    ProfileEdit,
    WorkExperiencesEdit,
    SchoolsEdit,
    EmptyMessage,
    Submissions
  },
  name: "profile",
  data(){
    return{
      user_data: null,
      profile: null,
      submissions: null,
      work_experiences: null,
      guardians: null,
      schools: null,
      errors: [],
      tab: 'basicInfo',
      empty: true,
      basicEmpty: true,
      basicEdit: false,
      schoolsEdit: false,
      workExpEdit: false
    }
  },
  mounted(){
    this.getProfile()
    this.getSubmissions()
  },
  methods:{
    toggleEditBasicInfo(){
      this.basicEdit = !this.basicEdit
      if (!this.basicEdit) {
        this.$forceUpdate()
        this.getProfile()
      }
    },
    toggleEditSchools(){
      this.schoolsEdit = !this.schoolsEdit
      if (!this.schoolsEdit) {
        this.getProfile()
      }
    },
    toggleEditWorkExp(){
      this.workExpEdit = !this.workExpEdit
      if (!this.workExpEdit) {
        this.getProfile()
      }
    },
    getProfile(){
      axios.get(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/`)
      .then( res => {
        this.profile = res.data.profile
        this.work_experiences = res.data.profile.work_experiences
        this.guardians = res.data.profile.guardians
        this.schools = res.data.profile.schools
        this.user_data = res.data.user
        this.updateProfileStore()
        this.empty = this.checkEmpty()
        this.basicEmpty = this.checkBasicEmpty()
      })
      .catch( err => {
        this.errors.push(err)
      })
    },
    checkEmpty(){
      for (var field in this.profile) {
        if (Array.isArray(this.profile[field])) {
          if (this.profile[field].length !== 0) {
            return false
          }
        } else {
          if ((this.profile[field] != null) && (field != 'id') && (this.profile[field] != '')) {
            return false
          }
        }
      }
      return true
    },
    checkBasicEmpty(){
      var basicFields = ['birthdate', 'city', 'country', 'state',
      'street', 'street2', 'zip']
      for (var field in basicFields) {
        if ((this.profile[basicFields[field]] != null) && (this.profile[basicFields[field]] != '')) {
          return false
        }
      }
      return true
    },
    getSubmissions(){
      axios.get(`${process.env.VUE_APP_ENDPOINT}/api/applicant/submissions/`)
      .then( res => {
        this.submissions = res.data.submissions
      })
      .catch( err => {
        this.errors.push(err)
      })
    },
    //updateProfileStore(){
    //  this.$store.commit('setProfileData', this.profile)
    //},
    formatDate(date){
      return date.substr(5, 2) + '/' + date.substr(8, 2) + '/'+ date.substr(0, 4)
    },
    formatType(type){
      var upper = type.charAt(0).toUpperCase() + type.slice(1)
      return upper.replace("_s", " S")
    },
  }
}
</script>

<style >

.social {
  height: 2em;
  right: 0px;
}

.display-label {
  display: inline-block;
  color: #1B86B5;
}

.display-text {
  display: inline-block;
  line-height: .5em;
}

.display-img {
  height: 2.5em;
  display: inline-block;
}

.editBtn {
  float: right;
  background-color: #27AAE1;
}

.editBtn:hover {
  background-color: #1B86B5;
}

.emptyBtn {
  background-color: #a6a6a6;
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
  margin-top: 10%;
}

.emptyBtn:hover {
  background-color: #666;
}

.emptyText {
  text-align: center;
  color: #a6a6a6;
  display: inline-block;
  margin-top: 10%;
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
}

.empty {
  width: 100%;
  background-color: #ededed;
  height: 500px;
  display: block;
}

.show {
  //background-color: #1B86B5 !important;
}

a, a:link, a:visited {
  text-decoration: none;}

li.my_tabs:hover {
  background-color: #1B86B5;
}

.my_tabs {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #27AAE1;
}
.my_tabs li {
  float: left;
  display: block;
  text-align: center;
  padding: 16px;
  text-decoration: none;
  color: white !important;
}

.bigger_font {
  font-size: 3em;
}

#prof_pic {
  border-radius: 20px;
  width: 100%;
  opacity: 1;
  display: block;
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}


.prof_container:hover #prof_pic {
  opacity: 0.3;
}

.prof_container:hover .middle {
  opacity: 1;
}

.prof_container {
  position: relative;
  width: 50%;
}

.text {
  background-color: #1B86B5;
  color: white;
  font-size: 16px;
  padding: 16px 32px;
}

.profile-text {
  font-size: 16px;
}


</style>
